import { render, staticRenderFns } from "./FlightsFiltersSkeleton.vue?vue&type=template&id=432a0b39"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCaret: require('/home/forge/ab.farescraper.com/components/IconsCaret.vue').default})
